import { fromBase64 } from "./util-base64/fromBase64.browser";
import { toBase64 } from "./util-base64/toBase64.browser";
import { bindUint8ArrayBlobAdapter } from "./util-stream/blob/Uint8ArrayBlobAdapter";
import { fromUtf8 } from "./util-utf8/fromUtf8.browser";
import { toUtf8 } from "./util-utf8/toUtf8.browser";
import { bindV4 } from "./uuid/v4";
const no = Symbol.for("node-only");
export { copyDocumentWithTransform } from "./copyDocumentWithTransform";
export { dateToUtcString, parseRfc3339DateTime, parseRfc3339DateTimeWithOffset, parseRfc7231DateTime, parseEpochTimestamp, } from "./date-utils";
export { LazyJsonString } from "./lazy-json";
export { logger, parseBoolean, expectBoolean, expectNumber, expectFloat32, expectInt, expectInt32, expectShort, expectByte, expectNonNull, expectObject, expectString, expectUnion, expectLong, strictParseDouble, strictParseFloat, strictParseFloat32, strictParseLong, strictParseInt, strictParseInt32, strictParseShort, strictParseByte, limitedParseDouble, handleFloat, limitedParseFloat, limitedParseFloat32, } from "./parse-utils";
export { quoteHeader } from "./quote-header";
export { _parseEpochTimestamp, _parseRfc3339DateTimeWithOffset, _parseRfc7231DateTime, } from "./schema-serde-lib/schema-date-utils";
export { splitEvery } from "./split-every";
export { splitHeader } from "./split-header";
export { NumericValue, nv } from "./value/NumericValue";
export { fromHex, toHex } from "./util-hex-encoding/hex-encoding";
export { toBase64, fromBase64 };
export { calculateBodyLength } from "./util-body-length/calculateBodyLength.browser";
export { toUint8Array } from "./util-utf8/toUint8Array.browser";
export { toUtf8, fromUtf8 };
export { concatBytes } from "./concatBytes";
export const fromArrayBuffer = no;
export const fromString = no;
export { isArrayBuffer } from "./is-array-buffer/is-array-buffer";
export { deserializerMiddleware } from "./middleware-serde/deserializerMiddleware";
export { deserializerMiddlewareOption, serializerMiddlewareOption, getSerdePlugin, } from "./middleware-serde/serdePlugin";
export { serializerMiddleware } from "./middleware-serde/serializerMiddleware";
export const Hash = no;
export class Uint8ArrayBlobAdapter extends bindUint8ArrayBlobAdapter(toUtf8, fromUtf8, toBase64, fromBase64) {
}
export { ChecksumStream } from "./util-stream/checksum/ChecksumStream.browser";
export { createChecksumStream } from "./util-stream/checksum/createChecksumStream.browser";
export { createBufferedReadable } from "./util-stream/createBufferedReadable.browser";
export { getAwsChunkedEncodingStream } from "./util-stream/getAwsChunkedEncodingStream.browser";
export { headStream } from "./util-stream/headStream.browser";
export { sdkStreamMixin } from "./util-stream/sdk-stream-mixin.browser";
export { splitStream } from "./util-stream/splitStream.browser";
export { isReadableStream, isBlob } from "./util-stream/stream-type-check";
export { streamCollector } from "./util-stream/stream-collector.browser";
const _getRandomValues = (array) => crypto.getRandomValues(array);
export const v4 = bindV4(_getRandomValues);
export const generateIdempotencyToken = v4;
